import React from "react";

import Box from "@mui/material/Box";

import { CreatePartnerDialog } from "./CreatePartnerDialog";
import { PartnerList } from "./PartnerList";

export const Management = () => {
  return (
    <Box>
      <CreatePartnerDialog />
      <PartnerList />
    </Box>
  );
};
